module.exports = __webpack_public_path__ + "img/Artboard1.49e28f1a.webp";